import { useState, useEffect, ReactNode } from 'react'
import { useTranslation } from 'react-i18next';
import { PageTitleBar } from './layout/PageBar';
import { ModemModelData, ModemModelDataList, MultipleModemsModelSchema } from '../api/Admin';
import { APIRequestGet } from '../utils/APIRequests';

function OnlineDrones(): ReactNode {
    const { t } = useTranslation(['nav_menu']);
    const [onlineImei, setOnlineImei] = useState<ModemModelDataList>([]);

    useEffect(() => {
        getOnlineDroneInfo();

        console.log("OnlineDrones mount");

        return () => {
            console.log("OnlineDrones unmount");
        };
    }, []);

    function getOnlineDroneInfo() {
        APIRequestGet(`/admin/getAllOnlineModem`, {
            schema: MultipleModemsModelSchema,
            logSuccess: true
        }).then((result) => {
            setOnlineImei(result.data.imeis);
        });
    }

    return (
        <>
            <PageTitleBar title={t('online_drones')} />
            <div className='max-width text-page-padding'>
                <div>Online: {onlineImei.length}</div>
                {/*onlineImei.map(imei => <div>{imei.imei} {imei.email} {imei.ip}</div>)*/}
                <table className='table table-striped' aria-labelledby="tableLabel">
                    <thead>
                        <tr>
                            <th>IMEI</th>
                            <th>Email</th>
                            <th>IP</th>
                        </tr>
                    </thead>
                    <tbody>
                        {onlineImei.map((imei: ModemModelData) =>
                            <tr key={imei.imei}>
                                <td>{imei.imei}</td>
                                <td>{imei.email}</td>
                                <td>{imei.ip}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default OnlineDrones;